import React from 'react';
import { LangContext } from '../contexts/lang.context';
import { Box } from '@material-ui/core';

export const Footer: React.FC = () => {
  const { APP } = React.useContext(LangContext).currentLangData;

  return (
    <Box maxWidth="600px">
      <Box px="6%" fontWeight="500" fontSize="h4.fontSize" color="primary.dark">
        {APP.contactUs}
      </Box>
      <iframe
        title="contact us"
        src="https://docs.google.com/forms/d/e/1FAIpQLSf_mg54R-dWBUkjcUml6o4Im-4wvi0W6_GYuls-PeWcax7C9w/viewform?embedded=true"
        width="100%"
        height="500"
        frameBorder={0}
        marginHeight={0}
        marginWidth={0}
      >
        Loading…
      </iframe>
    </Box>
  );
};
